import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import '../scss/customize.scss';

import Utility from "./class/utility";
import CUSTOMIZE from "./extended_class/customize";
import HOME from "./module/home";
import RECRUIT from "./module/recruit";
import DETAIL from "./module/detail";

// ユーティリティクラスのインスタンス化
const UTIL = new Utility();

// テンプレートインスタンス化（promise登録）
const TPL = new CUSTOMIZE();

// URLによる関数の実行
UTIL.loader( (request, path) => {
  switch( path ){
    case '/': 
      HOME(); 
      break;
    case '/recruit/': 
      DETAIL();
      RECRUIT(); 
      break;
    default: 
      DETAIL(); 
      break;
  }
});

// テンプレートインスタンスの初期化（イベント発火）
TPL.init();